// all styles here
import "./src/assets/css/bootstrap.min.css"
import "./src/assets/css/animate.min.css"
import "./src/assets/css/boxicons.min.css"
import "./src/assets/css/flaticon.css"
import "@fortawesome/fontawesome-free/css/all.min.css"
import './node_modules/react-modal-video/css/modal-video.min.css'
import 'react-accessible-accordion/dist/fancy-example.css'
import 'react-image-lightbox/style.css'
import "./src/assets/css/style.css"
import "./src/assets/css/responsive.css"

const loadNonCriticalScripts = () => {
  Promise.resolve()
    .then(() => import("jquery"))
    .then(({ default: $ }) => {
      window.$ = $
      window.jQuery = $
      return import("./src/assets/js/bootstrap.bundle.min.js")
    })
    .catch(() => {})
}

export const onClientEntry = () => {
  if (typeof window === "undefined") return

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(loadNonCriticalScripts, { timeout: 2000 })
    return
  }

  window.setTimeout(loadNonCriticalScripts, 1500)
}
